import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxTweetModule } from 'ngx-tweet';

import { CustomFieldsModule } from '../custom-fields/custom-fields.module';
import { AgentShortcutsModalComponent } from '../shared/components/agent-shortcuts-modal/agent-shortcuts-modal.component';
import { ChooseKakaotalkTemplateComponent } from '../shared/components/choose-template-flow/choose-kakaotalk-template/choose-kakaotalk-template.component';
import { ChooseSenderRecipientComponent } from '../shared/components/choose-template-flow/choose-sender-recipient/choose-sender-recipient.component';
import { ChooseTemplateFlowComponent } from '../shared/components/choose-template-flow/choose-template-flow.component';
import { ChooseWhatsappTemplateComponent } from '../shared/components/choose-template-flow/choose-whatsapp-template/choose-whatsapp-template.component';
import { ChooseWriteComponent } from '../shared/components/choose-template-flow/choose-write/choose-write.component';
import { ComposeMessageComponent } from '../shared/components/choose-template-flow/compose-message/compose-message.component';
import { PreviewAndSendComponent } from '../shared/components/choose-template-flow/preview-and-send/preview-and-send.component';
import { FavoritesModalComponent } from '../shared/components/favorites-modal/favorites-modal.component';
import { GifSearchModalComponent } from '../shared/components/gif-search-modal/gif-search-modal.component';
import { SharedModule } from '../shared/shared.module';
import { UserProfileModule } from '../user-profile/user-profile.module';
import { AcquireBeforeProcessingGuard } from './acquire-before-processing.guard';
import { AnnotationsModalComponent } from './annotations-modal/annotations-modal.component';
import { AnswerEditorComponent } from './answer-editor/answer-editor.component';
import { ReplyInAsToLineComponent } from './answer-editor/reply-in-as-to-line/reply-in-as-to-line.component';
import { SelectReplyToModalComponent } from './answer-editor/select-reply-to-modal/select-reply-to-modal.component';
import { SendAndAskForHelpComponent } from './answer-editor/send-and-popover/send-and-ask-for-help/send-and-ask-for-help.component';
import { SendAndPopoverComponent } from './answer-editor/send-and-popover/send-and-popover.component';
import { SendAndTeamSelectionComponent } from './answer-editor/send-and-popover/send-and-team-selection/send-and-team-selection.component';
import { SendAndTriggerSurveyComponent } from './answer-editor/send-and-popover/send-and-trigger-survey/send-and-trigger-survey.component';
import { ArchiveAndOtherActionsComponent } from './archive-and-other-actions/archive-and-other-actions.component';
import { ConfirmAnonymizeComponent } from './archive-and-other-actions/confirm-anonymize/confirm-anonymize.component';
import { SendByEmailPopoverComponent } from './archive-and-other-actions/send-by-email-popover/send-by-email-popover.component';
import { DesktopTPPRightColumnComponent } from './desktop-tpp-right-column/desktop-tpp-right-column.component';
import { HelpRequestsModalComponent } from './help-requests-modal/help-requests-modal.component';
import { DeleteMessageInTaskProcessComponent } from './message-in-task-process/delete-message-in-task-process-popover/delete-message-in-task-process-popover.component';
import { MessageInTaskProcessComponent } from './message-in-task-process/message-in-task-process.component';
import { PublicContextAndTaskActionsComponent } from './public-context-and-task-actions/public-context-and-task-actions.component';
import { PublicContextComponent } from './public-context-and-task-actions/public-context/public-context.component';
import { ConfirmStealComponent } from './public-context-and-task-actions/task-actions-log/confirm-steal/confirm-steal.component';
import { TaskActionsLogComponent } from './public-context-and-task-actions/task-actions-log/task-actions-log.component';
import { TaskProcessPageHeaderComponent } from './task-process-page-header/task-process-page-header.component';
import { TaskProcessPageComponent } from './task-process-page.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AcquireBeforeProcessingGuard],
    component: TaskProcessPageComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    RouterModule.forChild(routes),
    NgxTweetModule,
    SharedModule,
    UserProfileModule,
    CustomFieldsModule,
  ],
  declarations: [
    AgentShortcutsModalComponent,
    AnnotationsModalComponent,
    AnswerEditorComponent,
    ArchiveAndOtherActionsComponent,
    ConfirmAnonymizeComponent,
    ConfirmStealComponent,
    DeleteMessageInTaskProcessComponent,
    DesktopTPPRightColumnComponent,
    FavoritesModalComponent,
    GifSearchModalComponent,
    HelpRequestsModalComponent,
    MessageInTaskProcessComponent,
    PublicContextAndTaskActionsComponent,
    PublicContextComponent,
    ReplyInAsToLineComponent,
    SelectReplyToModalComponent,
    SendAndAskForHelpComponent,
    SendAndPopoverComponent,
    SendAndTeamSelectionComponent,
    SendAndTriggerSurveyComponent,
    SendByEmailPopoverComponent,
    TaskActionsLogComponent,
    TaskProcessPageComponent,
    TaskProcessPageHeaderComponent,
    // Engagement part
    ChooseKakaotalkTemplateComponent,
    ChooseSenderRecipientComponent,
    ChooseTemplateFlowComponent,
    ChooseWhatsappTemplateComponent,
    ChooseWriteComponent,
    ComposeMessageComponent,
    PreviewAndSendComponent,
  ],
  exports: [
    AnswerEditorComponent,
    DesktopTPPRightColumnComponent,
    MessageInTaskProcessComponent,
    TaskProcessPageHeaderComponent,
    ChooseKakaotalkTemplateComponent,
    ChooseSenderRecipientComponent,
    ChooseTemplateFlowComponent,
    ChooseWhatsappTemplateComponent,
    ChooseWriteComponent,
    ComposeMessageComponent,
    PreviewAndSendComponent,
  ],
})
export class TaskProcessPageModule {}
